// extracted by mini-css-extract-plugin
export default {"statisticsSummary":"StatisticsSummary_statisticsSummary__wsobw"};